import { Component, OnInit, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { BreadcrumbService } from '../../../../services/breadcrumb.service';
import { AppConfigService } from 'src/app/services/app-config.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html'
})
export class MainLayoutComponent implements OnInit, OnDestroy, AfterViewInit {

  crumbs$: Observable<MenuItem[]>;
  home: MenuItem;
  hasScrollBar: boolean;
  menuActive = true;

  constructor(private breadcrumb: BreadcrumbService,
    private configService: AppConfigService) { }

  ngOnInit() {
    this.hasScrollBar = false;
    this.crumbs$ = this.breadcrumb.crumbs$;
    this.home = { icon: 'pi pi-home', routerLink: '/', routerLinkActiveOptions: { exact: true } };
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {

  }

  get isNewsActive(): boolean {
    return this.configService.state.newsActive;
  }

  get isDarkMode(): boolean {
    return this.configService.config().darkMode;
  }

  get isRippleDisabled(): boolean {
    return this.configService.config().ripple === false;
  }

  get isMenuActive(): boolean {
    return this.configService.state.menuActive;
  }

  get theme(): string {
    return this.configService.config().theme;
  }

  get containerClass() {
    return {
      'layout-news-active': this.isNewsActive,
      'p-ripple-disabled': this.isRippleDisabled,
      'layout-dark': this.isDarkMode,
      'layout-light': !this.isDarkMode
    };
  }


  toggleDarkMode() {
    let newTheme = null;
    const { theme, darkMode } = this.configService.config();

    if (darkMode) {
      newTheme = theme.replace('dark', 'light');
    } else {
      if (theme.includes('light') && theme !== 'fluent-light') newTheme = theme.replace('light', 'dark');
      else newTheme = 'lara-dark-blue';
    }
    this.configService.config.update((config) => ({ ...config, darkMode: !darkMode, theme: newTheme }));
  }

}
